import * as Yup from 'yup';
import {getAmountUnits} from '../../../../utilities/helper/unitGenerator';
import {
  WantedRentFarmDurationUnits,
  WantedRentIrrigationDurationUnits,
} from '../../../../utilities/helper/unitGenerator/AmountUnits.config';
import {
  AdvertisementType,
  IInputUnit,
} from '../../../../utilities/helper/unitGenerator/unit.types';
import {ISrs_type} from '../types';
import {hasBadWords} from '../../../../utilities/helper/checkBadWords/hasBadWord';

export const adsTypes: ISrs_type[] = [
  {
    image: 'https://shop-advertisement.s3.ir-thr-at1.arvanstorage.ir/shop.svg',
    title: 'فروش نهاده و تجهیزات',
    type: 'sale',
  },
  {
    image:
      'https://shop-advertisement.s3.ir-thr-at1.arvanstorage.ir/basket.svg',
    title: 'خرید',
    type: 'buy',
  },
  {
    image:
      'https://shop-advertisement.s3.ir-thr-at1.arvanstorage.ir/traktor.svg',
    title: 'اجاره دادن و گرفتن',
    type: 'rent',
  },
  {
    image: 'https://shop-advertisement.s3.ir-thr-at1.arvanstorage.ir/seed.svg',
    title: 'ارائه و دریافت خدمات',
    type: 'service',
  },
];

export const adTypesRadio = [
  {title: 'آگهی شخصی', value: 'personal'},
  {title: 'آگهی فروشگاهی', value: 'store'},
];

type FormulationOptions = {
  title: string;
  value: string;
};

export const getFormulationTypeByValue = (
  value: string | null,
): FormulationOptions | undefined => {
  if (!value) return undefined;
  return Object.values(formulationTypesRadio)
    .flat()
    .find(item => item.value === value);
};

export const availableQuantityValidation = Yup.number()
  .required('تعیین موجودی فروشگاه آگهی الزامی است')
  .positive('موجودی باید بیشتر از صفر باشد')
  .integer('موجودی باید عدد صحیح باشد');

export const minSellQuantityValidation = Yup.number()
  .required('تعیین حداقل سفارش آگهی الزامی است')
  .positive('حداقل سفارش باید بیشتر از صفر باشد')
  .integer('حداقل سفارش باید عدد صحیح باشد')
  .test(
    'min-sell-not-exceed-available',
    'حداقل سفارش نمی‌تواند بیشتر از موجودی باشد',
    function (value) {
      const {available_quantity} = this.parent;

      if (!value || !available_quantity) {
        return true;
      }

      return value <= available_quantity;
    },
  );

export const formulationTypesRadio: Record<
  string,
  Array<FormulationOptions>
> = {
  11: [
    {title: 'جامد', value: 'solid'},
    {title: 'مایع', value: 'liquid'},
    {title: 'گرانول', value: 'granule'},
  ],
  12: [
    {title: 'مایع', value: 'liquid'},
    {title: 'پودر', value: 'powder'},
  ],
  13: [
    {title: 'محلی', value: 'native'},
    {title: 'اصلاح شده', value: 'modified'},
    {title: 'با گواهینامه', value: 'with_certificate'},
    {title: 'بدون گواهینامه', value: 'without_certificate'},
  ],
};

export const groupTitle: Record<string, string> = {
  sale: 'چه محصولی می‌فروشید؟ دسته‌ی آگهی را انتخاب کنید.',
  buy: 'قصد خرید چه محصولی را دارید‌؟ دسته‌ی آگهی را انتخاب کنید.',
  serviceprovidedService:
    ' چه خدمتی ارائه می‌دهید؟ دسته‌ی آگهی را انتخاب کنید.',
  servicewantedService: ' چه خدمتی نیاز دارید؟ دسته‌ی آگهی را انتخاب کنید.',
  rentprovidedRent:
    'قصد اجاره دادن چه چیزی را دارید‌؟ دسته‌ی آگهی را انتخاب کنید.',
  rentwantedRent:
    'قصد اجاره گرفتن چه چیزی را دارید‌؟ دسته‌ی آگهی را انتخاب کنید.',
};

export const inputTitlesBottomSheet: Record<string, () => JSX.Element> = {
  sale11: () => (
    <p>
      نوع کود را<strong> برای فروش </strong> انتخاب کنید.
    </p>
  ),
  sale12: () => (
    <p>
      نوع سم را <strong> برای فروش </strong> انتخاب کنید.
    </p>
  ),
  sale13: () => (
    <p>
      نوع بذر و نهال را<strong> برای فروش </strong> انتخاب کنید.
    </p>
  ),
  sale15: () => (
    <p>
      نوع ماشین آلات را<strong> برای فروش </strong> انتخاب کنید.
    </p>
  ),
  sale16: () => (
    <p>
      نوع ابزار و تجهیزات را<strong> برای فروش </strong> انتخاب کنید.
    </p>
  ),
  sale17: () => (
    <p>
      نوع مزرعه و آب را<strong> برای فروش </strong> انتخاب کنید.
    </p>
  ),
  buy11: () => (
    <p>
      نوع کود را<strong> برای خرید </strong> انتخاب کنید.
    </p>
  ),
  buy12: () => (
    <p>
      نوع سم را<strong> برای خرید </strong> انتخاب کنید.
    </p>
  ),
  buy13: () => (
    <p>
      نوع بذر و نهال را<strong> برای خرید </strong> انتخاب کنید.
    </p>
  ),
  buy15: () => (
    <p>
      نوع ماشین آلات را<strong> برای خرید </strong> انتخاب کنید.
    </p>
  ),
  buy16: () => (
    <p>
      نوع ابزار و تجهیزات را<strong> برای خرید </strong> انتخاب کنید.
    </p>
  ),
  buy17: () => (
    <p>
      نوع مزرعه و آب را<strong> برای خرید </strong> انتخاب کنید.
    </p>
  ),
  rent15providedRent: () => (
    <p>
      نوع ماشین آلات <strong> برای اجاره دادن </strong>را انتخاب کنید.
    </p>
  ),
  rent17providedRent: () => (
    <p>
      نوع مزرعه و آب <strong> برای اجاره دادن </strong>را انتخاب کنید.
    </p>
  ),
  rent15wantedRent: () => (
    <p>
      نوع ماشین آلات <strong> برای اجاره گرفتن </strong>را انتخاب کنید.
    </p>
  ),
  rent17wantedRent: () => (
    <p>
      نوع مزرعه و آب <strong> برای اجاره گرفتن </strong>را انتخاب کنید.
    </p>
  ),
  service14providedService: () => (
    <p>
      نوع <strong> کار کشاورزی که ارائه می‌دهید </strong>
      را انتخاب کنید.
    </p>
  ),
  service14wantedService: () => (
    <p>
      نوع <strong> کار کشاورزی که نیاز دارید </strong>
      را انتخاب کنید.
    </p>
  ),
  service15wantedService: () => (
    <p>
      نوع <strong> خدمات مکانیزاسیونی که نیاز دارید </strong>
      را انتخاب کنید.
    </p>
  ),
  service15providedService: () => (
    <p>
      نوع <strong> خدمات مکانیزاسیونی که ارائه می‌دهید </strong>
      را انتخاب کنید.
    </p>
  ),

  service18wantedService: () => (
    <p>
      نوع <strong> آزمایشگاه مورد نیاز </strong>
      را انتخاب کنید.
    </p>
  ),
};

export const farmOptions = [
  {id: '1', title: 'می‌خواهم اجاره دهم', value: 'providedRent'},
  {id: '2', title: 'می‌خواهم اجاره بگیرم', value: 'wantedRent'},
];

export const serviceOptions = [
  {id: '1', title: 'خدمات ارائه می‌دهم', value: 'providedService'},
  {id: '2', title: 'خدمات نیاز دارم', value: 'wantedService'},
];

export const ChoosenFilteredInput: Record<
  string,
  Record<number, Array<string> | undefined>
> = {
  sale: {
    11: undefined,
    12: undefined,
    13: undefined,
    14: undefined,
    15: ['12', '13', '14', '15', '16'],
    16: undefined,
    17: ['12'],
    18: undefined,
  },
  buy: {
    11: undefined,
    12: undefined,
    13: undefined,
    14: undefined,
    15: ['12', '13', '14', '15', '16'],
    16: undefined,
    17: ['12'],
    18: undefined,
  },
  service: {
    11: undefined,
    12: undefined,
    13: undefined,
    14: undefined,
    15: ['11', '17'],
    16: undefined,
    17: ['12'],
    18: undefined,
  },
  rent: {
    11: undefined,
    12: undefined,
    13: undefined,
    14: undefined,
    15: ['12', '13', '14', '15', '16'],
    16: undefined,
    17: ['12'],
    18: undefined,
  },
};

const badWordTest = Yup.string().nullable().test(
  'has-bad-word',
  'توضیحات شامل کلمات غیرمجاز است',
  value => !hasBadWords(value ?? ''),
);
export const validateExemple = (sub_input?: string, input_group?: string) => {
  const somthing: Record<string, any> = {
    sale11: {
      sub_input: Yup.object().shape({
        guid: Yup.string().required(
          `انتخاب نوع ${input_group} ${sub_input} الزامی است`,
        ),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        )
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      discount_amount: Yup.string().notRequired().nullable(),
      location: Yup.object().shape({
        lat: Yup.string().required('آدرس الزامی است'),
        lng: Yup.string().required('آدرس الزامی است'),
      }),
      // main_image: Yup.number().when('sub_brand_main_image', {
      //   is: (value: number) => !value,
      //   then: Yup.number().required('تصویر کاور آگهی را انتخاب کنید'),
      //   otherwise: Yup.number().notRequired().nullable(),
      // }),
      // sub_brand_main_image: Yup.number().when('main_image', {
      //   is: (value: number) => !value,
      //   then: Yup.number().required('تصویر کاور آگهی را انتخاب کنید'),
      //   otherwise: Yup.number().notRequired().nullable(),
      // }),
      selectedMainImg: Yup.number()
        .nullable()
        .transform((value, originalValue) => {
          if (
            originalValue === '' ||
            originalValue === null ||
            originalValue === undefined
          )
            return null;
          return Number(originalValue);
          // .when('hasImages', {
          //   is: true,
          //   then: schema => schema.required('تصویر کاور آگهی را انتخاب کنید'),
          //   otherwise: schema => schema.notRequired(),
          // })
        }),
      quantity_pack: Yup.string().required(' تعیین وزن بسته بندی الزامی است'),
      description: badWordTest,
      quantity_pack_unit: Yup.object({
        value: Yup.string().required('انتخاب واحد الزامی است'),
        title: Yup.string().nullable(),
      }).required('انتخاب واحد الزامی است'),
      available_quantity: availableQuantityValidation,
      min_sell_quantity: minSellQuantityValidation,
      combinations: badWordTest,
      application_method: badWordTest,
    },
    sale12: {
      sub_input: Yup.object().shape({
        // title: Yup.string().required(
        //   `انتخاب نوع ${input_group} ${sub_input} الزامی است`,
        // ),
        guid: Yup.string().required(
          `انتخاب نوع ${input_group} ${sub_input} الزامی است`,
        ),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        )
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      description: badWordTest,
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      discount_amount: Yup.string().notRequired().nullable(),
      location: Yup.object().shape({
        lat: Yup.string().required('آدرس الزامی است'),
        lng: Yup.string().required('آدرس الزامی است'),
      }),
      quantity_pack: Yup.string().required(' تعیین وزن بسته بندی الزامی است'),
      quantity_pack_unit: Yup.object({
        value: Yup.string().required('انتخاب واحد الزامی است'),
        title: Yup.string().nullable(),
      }).required('انتخاب واحد الزامی است'),
      available_quantity: availableQuantityValidation,
      min_sell_quantity: minSellQuantityValidation,
      combinations: badWordTest,
      application_method: badWordTest,
    },
    sale13: {
      sub_input: Yup.object().shape({
        // title: Yup.string().required(
        //   `انتخاب نوع ${input_group} ${sub_input} الزامی است`,
        // ),
        guid: Yup.string().required(
          `انتخاب نوع ${input_group} ${sub_input} الزامی است`,
        ),
      }),
      description: badWordTest,
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      discount_amount: Yup.string().notRequired().nullable(),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
      quantity_pack: Yup.string().required(' تعیین وزن بسته بندی الزامی است'),
      quantity_pack_unit: Yup.object({
        value: Yup.string().required('انتخاب واحد الزامی است'),
        title: Yup.string().nullable(),
      }).required('انتخاب واحد الزامی است'),
      available_quantity: availableQuantityValidation,
      min_sell_quantity: minSellQuantityValidation,
      combinations: badWordTest,
      application_method: badWordTest,
    },
    sale15: {
      sub_input: Yup.object().shape({
        ////  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      description: badWordTest,
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      discount_amount: Yup.string().notRequired().nullable(),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
      quantity_pack: Yup.string().required(' تعیین وزن بسته بندی الزامی است'),
      quantity_pack_unit: Yup.object({
        value: Yup.string().required('انتخاب واحد الزامی است'),
        title: Yup.string().nullable(),
      }).required('انتخاب واحد الزامی است'),
      available_quantity: availableQuantityValidation,
      min_sell_quantity: minSellQuantityValidation,
      combinations: badWordTest,
      application_method: badWordTest,
    },
    sale16: {
      sub_input: Yup.object().shape({
        ////  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        )
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      description: badWordTest,
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      discount_amount: Yup.string().notRequired().nullable(),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
      quantity_pack: Yup.string().required(' تعیین وزن بسته بندی الزامی است'),
      quantity_pack_unit: Yup.object({
        value: Yup.string().required('انتخاب واحد الزامی است'),
        title: Yup.string().nullable(),
      }).required('انتخاب واحد الزامی است'),
      available_quantity: availableQuantityValidation,
      min_sell_quantity: minSellQuantityValidation,
      combinations: badWordTest,
      application_method: badWordTest,
    },
    sale1711: {
      sub_input: Yup.object().shape({
        ////  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        )
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      description: badWordTest,
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      discount_amount: Yup.string().notRequired().nullable(),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
      farm: Yup.object().shape({
        name: Yup.string().required('انتخاب مزرعه الزامی است'),
        guid: Yup.string().required('انتخاب مزرعه الزامی است'),
      }),
      combinations: badWordTest,
      application_method: badWordTest,
    },
    sale1713: {
      sub_input: Yup.object().shape({
        ////  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        )
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      description: badWordTest,
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      discount_amount: Yup.string().notRequired().nullable(),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
      combinations: badWordTest,
      application_method: badWordTest,
    },
    buy11: {
      sub_input: Yup.object().shape({
        ////  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      wanted_weight: Yup.string().required('تعیین مقدار محصول الزامی است'),
      location: Yup.object().shape({
        lat: Yup.string().required('آدرس الزامی است'),
        lng: Yup.string().required('آدرس الزامی است'),
      }),
    },
    buy12: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_weight: Yup.string().required('تعیین مقدار محصول الزامی است'),
      location: Yup.object().shape({
        lat: Yup.string().required('آدرس الزامی است'),
        lng: Yup.string().required('آدرس الزامی است'),
      }),
    },
    buy13: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_weight: Yup.string().required('تعیین مقدار محصول الزامی است'),
      location: Yup.object().shape({
        lat: Yup.string().required('آدرس الزامی است'),
        lng: Yup.string().required('آدرس الزامی است'),
      }),
    },
    buy15: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_number: Yup.string().required('تعیین تعداد محصول الزامی است'),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
    },
    buy16: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_number: Yup.string().required('تعیین تعداد محصول الزامی است'),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
    },
    buy1711: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      area: Yup.string().required('تعیین مساحت زمین الزامی است'),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
    },
    buy1713: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      renting_duration: Yup.string().required(
        'مدت زمان مورد نیاز برای خرید حق آبه الزامی است',
      ),
      location: Yup.object().shape({
        lat: Yup.string().required(),
        lng: Yup.string().required(),
      }),
    },
    providedRent1511: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string().required('تعیین تعداد محصول الزامی است'),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedRent1517: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string().required('تعیین تعداد محصول الزامی است'),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedRent1711: {
      // farm: Yup.object().shape({
      //   title: Yup.string().required(`انتخاب نوع مزرعه الزامی است`),
      //   value: Yup.string().required(`انتخاب نوع مزرعه الزامی است`),
      // }),
      farm: Yup.object().shape({
        name: Yup.string().required(`انتخاب نوع زمین الزامی است`),
        guid: Yup.string().required(`انتخاب نوع زمین الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedRent1713: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    wantedRent1511: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_number: Yup.string().required('تعیین تعداد محصول الزامی است'),
      requirement_during: Yup.string().required(
        'مدت زمان مورد نیاز خود را وارد کنید',
      ),
    },
    wantedRent1517: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_number: Yup.string().required('تعیین تعداد محصول الزامی است'),
      requirement_during: Yup.string().required(
        'مدت زمان مورد نیاز خود را وارد کنید',
      ),
    },
    wantedRent1711: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      area: Yup.string().required('مساحت مورد نیاز خود را تعیین کنید'),
      renting_duration: Yup.string().required(
        'مدت زمان مورد نیاز خود را وارد کنید',
      ),
    },
    wantedRent1713: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      renting_duration: Yup.string().required(
        'مدت زمان مورد نیاز خود را وارد کنید',
      ),
    },
    providedService1512: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedService1513: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedService1514: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedService1515: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedService1516: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('price_on_call', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
        otherwise: Yup.number().notRequired().nullable(),
      }),
      description: badWordTest,
    },
    providedService1411: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      name: Yup.string().required(' نام و نام خانوادگی الزامی است'),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('negotiated_price', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
      }),
      description: badWordTest,
    },
    providedService1412: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      name: Yup.string().required(' نام و نام خانوادگی الزامی است'),
      title: Yup.string()
        .required('انتخاب عنوان آگهی الزامی است')
        .max(45, obj => {
          return 'تعداد حروف وارد شده بیش از حد مجاز است.';
        }),
      ad_price: Yup.number().when('negotiated_price', {
        is: false,
        then: Yup.number()
          .required(' تعیین قیمت الزامی است')
          .max(999999999999, 'مقدار نباید بیشتر از 12 رقم باشد'),
      }),
      description: badWordTest,
    },
    wantedService1411: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_number: Yup.string().required('تعیین تعداد نفرات الزامی است'),
      employing_duration: Yup.string().required(
        'تعیین مدت زمان مورد نیاز الزامی است',
      ),
    },
    wantedService1412: {
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      wanted_number: Yup.string().required('تعیین تعداد نفرات الزامی است'),
      employing_duration: Yup.string().required(
        'تعیین مدت زمان مورد نیاز الزامی است',
      ),
      employing_duration_unit: Yup.object({
        value: Yup.string().required('انتخاب واحد الزامی است'),
        title: Yup.string().nullable(),
      }),
    },
    wantedService1811: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1812: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1813: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1814: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1512: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      cultivation: Yup.object().shape({
        title: Yup.string().required('انتخاب کشت الزامی است.'),
        guid: Yup.string().required('انتخاب کشت الزامی است.'),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1513: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      cultivation: Yup.object().shape({
        title: Yup.string().required('انتخاب کشت الزامی است.'),
        guid: Yup.string().required('انتخاب کشت الزامی است.'),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1514: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      cultivation: Yup.object().shape({
        title: Yup.string().required('انتخاب کشت الزامی است.'),
        guid: Yup.string().required('انتخاب کشت الزامی است.'),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1515: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      cultivation: Yup.object().shape({
        title: Yup.string().required('انتخاب کشت الزامی است.'),
        guid: Yup.string().required('انتخاب کشت الزامی است.'),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
    wantedService1516: {
      sub_input: Yup.object().shape({
        //  title: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
        guid: Yup.string().required(`انتخاب نوع ${sub_input} الزامی است`),
      }),
      cultivation: Yup.object().shape({
        title: Yup.string().required('انتخاب کشت الزامی است.'),
        guid: Yup.string().required('انتخاب کشت الزامی است.'),
      }),
      title: Yup.string()
        .required('متن درخواست الزامی است')
        .test(
          'has-bad-word',
          'توضیحات شامل کلمات غیرمجاز است',
          value => !hasBadWords(value ?? ''),
        ),
    },
  };
  return somthing;
};

export const productQuantityTitle: Record<string, () => JSX.Element> = {
  buy11: () => (
    <p className="text-md">
      مقدار محصول مورد نیازتان را تعیین کنید
      <span className="color-red-3">*</span>
    </p>
  ),
  buy12: () => (
    <p className="text-md">
      مقدار محصول مورد نیازتان را تعیین کنید
      <span className="color-red-3">*</span>
    </p>
  ),
  buy13: () => (
    <p className="text-md">
      مقدار محصول مورد نیازتان را تعیین کنید
      <span className="color-red-3">*</span>
    </p>
  ),
  buy14: () => (
    <p className="text-md">
      مساحت زمین مورد نیازتان را وارد کیند
      <span className="color-red-3">*</span>
    </p>
  ),
  buy15: () => (
    <p className="text-md">
      تعداد محصول مورد نیازتان را تعیین کنید
      <span className="color-red-3">*</span>
    </p>
  ),
  buy16: () => (
    <p className="text-md">
      تعداد محصول مورد نیازتان را تعیین کنید
      <span className="color-red-3">*</span>
    </p>
  ),
  buy1711: () => (
    <p className="text-md">
      مساحت زمین مورد نیازتان را وارد کنید
      <span className="color-red-3">*</span>
    </p>
  ),
  buy1713: () => (
    <p className="text-md">
      مدت زمان مورد نیازتان را تعیین کنید
      <span className="color-red-3">*</span>
    </p>
  ),
};

export const gender: Array<{title: string; value: string}> = [
  {title: 'زن', value: 'female'},
  {title: 'مرد', value: 'male'},
];

export const requestDateUnit: Array<{title: string; value: string}> = [
  {title: 'ساعت', value: 'hour'},
  {title: 'روز', value: 'day'},
  {title: 'ماه', value: 'month'},
];

export const quantityPackProps: Record<string, string> = {
  11: '{"inputName":"wanted_weight" ,"bottomSheetName":"weight_unit" ,"label":"مقدار مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"" }',
  12: '{"inputName":"wanted_weight" ,"bottomSheetName":"weight_unit" ,"label":"مقدار مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"" }',
  13: '{"inputName":"wanted_weight" ,"bottomSheetName":"weight_unit" ,"label":"مقدار مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"" }',
  15: '{"inputName":"wanted_number" ,"bottomSheetName":"weight_unit" ,"label":"تعداد مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"" }',
  16: '{"inputName":"wanted_number" ,"bottomSheetName":"weight_unit" ,"label":"تعداد مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"" }',
  1711: '{"inputName":"area" ,"bottomSheetName":"area_unit" ,"label":"مساحت مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"" }',
  1713: '{"inputName":"renting_duration" ,"bottomSheetName":"renting_duration_unit" ,"label":"مدت زمان مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"" }',
};

export const quantityPackPropsRent: Record<string, string[]> = {
  1711: [
    '{"inputName":"area" ,"bottomSheetName":"area_unit" ,"label":"مساحت مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"","titleInput":"مساحت زمین مورد نیازتان را وارد کیند.","require":"true" }',
    '{"inputName":"renting_duration" ,"bottomSheetName":"renting_duration_unit" ,"label":"مدت زمان مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"","titleInput":"مدت زمان مورد نیازتان را تعیین کنید","require":"true" }',
  ],
  1713: [
    '{"inputName":"renting_duration" ,"bottomSheetName":"renting_duration_unit" ,"label":"مدت زمان مورد نیاز" ,"secondaryTitle":"" ,"placeholder":"","titleInput":"مدت زمان مورد نیازتان را تعیین کنید","require":"true" }',
  ],
};

export const emptyQuantityPack = {
  quantity_pack: '',
  quantity_pack_unit: {
    vlaue: '',
    title: '',
  },
};

export const validateInitialValue = (
  inputValueUnit: IInputUnit[],
  inputPriceUnit: IInputUnit[],
) => {
  const shouldAutoFillAmountUnit = inputValueUnit.length === 1;
  const defaultAmountUnit = inputValueUnit[0];

  const quantityPackDefaults = shouldAutoFillAmountUnit && {
    quantity_pack: 1,
    quantity_pack_unit: defaultAmountUnit,
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialValue: Record<string, any> = {
    sale11: {
      // type: {title: 'جامد', value: 'solid'},
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    sale12: {
      // type: {title: 'مایع', value: 'liquid'},
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    sale13: {
      // type: {title: 'محلی', value: 'native'},
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    sale15: {
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    sale16: {
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    sale1711: {
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    sale1713: {
      price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    buy11: {
      weight_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    buy12: {
      weight_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    buy13: {
      weight_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    buy15: {
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    buy16: {
      weight_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    buy1711: {
      area_unit: inputValueUnit && inputValueUnit[0],
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    buy1713: {
      renting_duration_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
      ad_type: {title: 'شخصی', value: 'personal'},
      ...quantityPackDefaults,
    },
    wantedRent1511: {
      request_date_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
    },
    providedRent1517: {
      price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
    },
    providedRent1511: {
      price_unit: getAmountUnits(
        'providedRent' as AdvertisementType,
        15,
        11,
      )[0],
      price_on_call: false,
    },
    wantedRent1517: {
      request_date_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
    },
    providedRent1711: {
      price_unit: getAmountUnits(
        'providedRent' as AdvertisementType,
        17,
        11,
      )[0],
      price_on_call: false,
    },
    providedRent1713: {
      price_unit: getAmountUnits(
        'providedRent' as AdvertisementType,
        17,
        13,
      )[0],
      price_on_call: false,
    },
    wantedRent1711: {
      area_unit: getAmountUnits('wantedRent' as AdvertisementType, 17, 11)[0],
      renting_duration_unit: WantedRentFarmDurationUnits[0],
    },
    wantedRent1713: {
      renting_duration_unit: WantedRentIrrigationDurationUnits[0],
    },
    providedService1512: {
      price_unit: (inputPriceUnit && inputPriceUnit?.[0]) ?? {
        title: 'در ساعت',
        value: 'per_hour',
      },
      quantity_pack: null,
      price_on_call: false,
    },
    providedService1513: {
      price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
      quantity_pack: null,
    },
    providedService1514: {
      price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
      quantity_pack: null,
    },
    providedService1515: {
      price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
      quantity_pack: null,
    },
    providedService1516: {
      price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
      quantity_pack: null,
    },
    providedService1411: {
      price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
    },
    providedService1412: {
      employee_price_unit: inputPriceUnit && inputPriceUnit?.[0],
      price_on_call: false,
    },
    wantedService1411: {
      employing_duration_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
    },
    wantedService1412: {
      employing_duration_unit: inputValueUnit && inputValueUnit[0],
      price_on_call: false,
    },
  };
  return initialValue;
};

export const validateInitialValueOptionalForm = (
  volume_units_1?: {title: string; guid: string}[],
  volume_units_2?: {title: string; guid: string}[],
  optionalFormData?: string,
) => {
  const initialValue: Record<
    string,
    string | number | undefined | Record<string, string | number | undefined>
  > = {
    irrigation_volume_time: volume_units_2 && volume_units_2[0],
    irrigation_volume_unit: volume_units_1 && volume_units_1[0],
    ...(optionalFormData && JSON.parse(optionalFormData)),
  };

  return initialValue;
};

export const get_times_hours = (x: number) => {
  return {
    title: x < 10 ? `0${x}:00` : `${x}:00`,
    guid: x,
  };
};
